<template>
  <div class="page-home" :class="{'mobile': _isMobile}">
    <div class="home-wrap" :class="{'pc': !_isMobile}">
      <!-- banner -->
      <div class="banner-box">
        <div class="swiper-container1">
          <div class="swiper-wrapper">
            <div class="swiper-slide" :class="{'g-pointer': item.url}" v-for="(item, index) in bannerList"
              :key="index" @click="goOutLink(item)">
              <img :src="item.picture" alt="">
            </div>
          </div>
          <!-- <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div> -->
          <div class="swiper-pagination swiper-pagination1"></div>
        </div>
      </div>

      <!-- 资讯 -->
      <div class="section section-info">
        <div class="item item-l">
          <h1>资讯动态</h1>
          <p class="eng">Information</p>
        </div>
        <div class="item item-c">
          <div class="info-list">
            <div class="it" v-for="(item, index) in data.information" :key="index" @click="goDetail('7', item)">
              <p class="time">{{item.publishTime}}</p>
              <p class="two-ell">{{item.name}}</p>
            </div>
            <div class="btn-more" @click="goDetail('1')">更多</div>
          </div>
          <div class="anim-circle"></div>
        </div>
        <div class="item item-r" :span="_isMobile?24:9">
          <h1>开放时间</h1>
          <p class="eng">Opening Hours</p>
          <p class="tip">周一闭馆、法定节假日除外</p>
          <div class="time-range">
            <div>
              <p class="name">开馆</p>
              <p class="time">{{museumInfo.openTime}}</p>
            </div>
            <div class="line"></div>
            <div>
              <p class="name">闭馆</p>
              <p class="time">{{museumInfo.closeTime}}</p>
            </div>
          </div>
          <div class="tickt btn-more">
            <p>预约入馆</p>
            <div class="pic-pop anim">
              <div class="pic">
                <img :src="$store.state.app.globalInfo.museumInfo.qrcodeWx" alt="" title="">
                <!-- <p><i class="icon icon-1"></i> 微信购票</p> -->
              </div>
              <!-- <div class="pic" v-if="$store.state.app.globalInfo.museumInfo.qrcodeMt">
                <img :src="$store.state.app.globalInfo.museumInfo.qrcodeMt" alt="" title="">
                <p><i class="icon icon-2"></i> 美团APP购票</p>
              </div>
              <div class="pic" v-if="$store.state.app.globalInfo.museumInfo.qrcodeCtrip">
                <img :src="$store.state.app.globalInfo.museumInfo.qrcodeCtrip" alt="" title="">
                <p><i class="icon icon-3"></i> 携程APP购票</p>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- 陈列展览、馆藏精品 -->
      <div class="section section-exhibit1">
        <div class="left">
          <div class="intro-box">
            <div class="it_title">
              <h1>陈列展览</h1>
              <p class="eng">Exhibition</p>
            </div>
            <div class="intro" v-if="data.exhibition && data.exhibition.length">
              <p class="name ell">{{data.exhibition[exhiIndex] && data.exhibition[exhiIndex].name}}</p>
              <p class="desc two-ell">{{data.exhibition[exhiIndex] && data.exhibition[exhiIndex].text}}</p>
              
              <div class="btn-box">
                <div class="btn-more-black" @click="goDetail('8')">更多</div>
              </div>
            </div>
          </div>

          <div class="swiper-container swiper-exhibit-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in data.exhibition" :key="index" @click="goDetail('3', item)">
                <div class="pic" style="cursor: pointer;">
                  <img :src="item.picture" alt="">
                </div>
              </div>
            </div>

            <div class="swiper-pagination swiper-pagination1"></div>
          </div>
        </div>

        <div class="right">
          <div class="collect-box">
            <div class="item item-1" v-for="(item, index) in data.collect" :key="index" @click="goDetail('4', item)">
              <img :src="item.picture" alt="">
            </div>
          </div>
          <div class="it_title">
            <h1>馆藏精品</h1>
            <p class="eng">Collection</p>

            <div class="btn btn-more-black" @click="goDetail('9')">更多</div>
          </div>
        </div>
      </div>

      <div class="section section-video">
        <!-- <div class="name-box">
          <p class="icon-box">
            <img src="~@images/pic_logo1.png" alt="">
          </p>
          <p class="ell" style="flex: 1;">{{detailData.name}}</p>
        </div> -->

        <div class="video-wrap">
          <videoPlayer class="video-box" :video-url="detailData.url" :videoId="detailData.id" :state="!detailData.stopVideo" :name="detailData.name"></videoPlayer>

          <div class="btn btn-left" :class="{'disable': videoIndex<1}" @click="goPrev"><i></i></div>
          <div class="btn btn-right" :class="{'disable': videoIndex>=testVideoList.length-1}" @click="goNext"><i></i></div>
        </div>
        
      </div>

      <!-- 社教 -->
      <div class="section section-activity">
        <div class="item">
          <div class="txt" @click="goDetail('10')">
            <div class="name">
              <p>社会教育</p>
              <p class="eng">Education</p>
            </div>
            <i class="icon-arrow"></i>
          </div>
        </div>
        <div class="item">
          <div class="txt" @click="goDetail('11')">
            <div class="name">
              <p>文创产品</p>
              <p class="eng">Cultural & Creative Products</p>
            </div>
            <i class="icon-arrow"></i>
          </div>
        </div>
      </div>

      <!-- 展览 -->
      <el-row class="section section-exhibit" :gutter="0" style="display: none;">
        <el-col class="item item-l" :span="_isMobile?24:6">
          <h1>展览</h1>
          <p class="eng">Exhibit</p>
        </el-col>
        <el-col class="item" :span="_isMobile?24:9" v-for="(item, index) in data.exhibition" :key="index" @click.native="goDetail('3', item)">
          <div class="pic-box">
            <img v-lazy="item.picture" alt="">
          </div>
          <div class="info">
            <h2 class="ell">{{item.name}}</h2>
            <!-- <p class="time">??? 2023.07.25~2023.09.10</p> -->
          </div>
        </el-col>
      </el-row>
      <div class="section section-display" style="display: none;">
        <!-- 轮播 -->
        <div class="tab-wrap">
          <div class="year-list">
            <div class="swiper-container swiper-year-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" :class="{'active': item.val==activeYear}" v-for="(item, i) in yearList" :key="i" @click="changeYear(item)">
                  <div class="line"></div>
                  <p class="name">{{item.name}}</p>
                  <p class="year">{{item.year}}</p>
                </div>
              </div>
            </div>
            <div class="swiper-button-prev swiper-button-white"><i></i> </div>
            <div class="swiper-button-next swiper-button-black"><i></i> </div>
          </div>

          <div class="swiper-box">
            <div class="swiper-container swiper-display-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in collectData" :key="index" @click="goDetail('4', item)">
                  <div class="pic_bg" :style="{backgroundImage:'url(' + item.picture + ')'}"></div>
                  <div class="pic-box">
                    <!-- <img :src="item.picture" alt=""> -->
                    <img v-lazy="item.picture" alt="">
                    <!-- <p style="position: relative; margin-top: -30px;">{{ item.name }}</p> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-button-prev swiper-button-white"></div>
            <div class="swiper-button-next swiper-button-black"></div>
            <!-- <div class="swiper-pagination swiper-pagination-display"></div> -->
          </div>
        </div>
      </div>

      <!-- 观众留言 -->
      <el-row class="section section-leave" :gutter="0" style="display: none;">
        <el-col class="item" :span="_isMobile?24:12">
          <div class="txt" @click="goDetail('5')">
            <p>失物登记</p>
            <i class="icon-arrow"></i>
          </div>
        </el-col>
        <el-col class="item" :span="_isMobile?24:12">
          <div class="txt" @click="goDetail('6')">
            <p>观众留言</p>
            <i class="icon-arrow"></i>
          </div>
        </el-col>
      </el-row>

      <!-- 常见问题 -->
      <!-- <div class="section section-question">
        <div class="question-con">
          <h2>常见问题</h2>

          <div class="list">
            <div class="item" :class="{'active': item.active}" v-for="(item, index) in data.question" :key="index">
              <div class="title-box">
                <p class="title">{{item.name}}</p>
                <i class="icon-expand" @click="handleOpen(item, index)"></i>
              </div>
              <div class="res" v-html="item.content"></div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import videoPlayer from '@cmp/video-player'

import '@assets/css-mobile/home/index.scss'
export default {
  components: { videoPlayer },
  data() {
    return {
      


      bannerList: [],
      data: {
        activityList: [],
        liuyanList: [{},{},{},{}]
      },
      museumInfo: {},
      collectData: [],
      activeYear: '1',
      yearList: [
        {
          name: '文明曙光',
          year: '1百万年前',
          val: '1'
        },
        {
          name: '夏朝',
          year: '公元前2070年 ',
          val: '2'
        },
        {
          name: '商朝',
          year: '公元前1600年',
          val: '3'
        },
        {
          name: '西周',
          year: '公元前1046年',
          val: '4'
        },
        {
          name: '春秋战国',
          year: '公元前770年',
          val: '5'
        },
        {
          name: '秦朝',
          year: '公元前221年',
          val: '6'
        },
        {
          name: '汉朝',
          year: '公元前220年',
          val: '7'
        },
        {
          name: '三国两晋南北朝',
          year: '公元184年',
          val: '8'
        },
        {
          name: '隋朝',
          year: '公元581年',
          val: '9'
        },
        {
          name: '唐朝',
          year: '公元618年',
          val: '10'
        },
        {
          name: '五代十国',
          year: '公元907年',
          val: '11'
        },
        {
          name: '辽夏金',
          year: '公元907年',
          val: '12'
        },
        {
          name: '宋朝',
          year: '公元960年 ',
          val: '13'
        },
        {
          name: '元朝',
          year: '公元1271年',
          val: '14'
        },
        {
          name: '明朝',
          year: '公元1368年',
          val: '15'
        },
        {
          name: '清朝',
          year: '公元1636年',
          val: '16'
        },
        {
          name: '民国',
          year: '公元1912年',
          val: '17'
        }
      ],
      mySwiper: null,
      mySwiper2: null,

      exhiIndex: 0,
      videoIndex: 0,
      testVideoList: [
        // {
        //   id: 'video1',
        //   url: 'http://cpqbwg.cn/mpsource/defaultBucket/1909801039658307585.mp4',
        //   stopVideo: false,
        // },
        // {
        //   id: 'video2',
        //   url: 'http://cpqbwg.cn/mpsource/defaultBucket/1909801525908164610.mp4',
        //   stopVideo: false,
        // },
        // {
        //   id: 'video3',
        //   url: 'http://cpqbwg.cn/mpsource/defaultBucket/1909801975529164802.mp4',
        //   stopVideo: false,
        // }
      ],
      detailData: {
        name: '',
        id: 'video1',
        url: 'https://www.w3school.com.cn/i/movie.mp4',
        stopVideo: false
      }, // todo dele  
    }
  },
  methods: {
    getData() {
      this.$http
        .get('/webapi/index', {})
        .then(res => {
          if (res.success) {
            let data = res.data
            this.data = data
            this.bannerList = data.slideshow
            this.museumInfo = data.museumInfo
            this.testVideoList = data.video || []
            if(this.testVideoList.length) {
              this.detailData = {
                id: this.testVideoList[0].id,
                name: this.testVideoList[0].name,
                url: this.testVideoList[0].video,
                picUrl: this.testVideoList[this.videoIndex].picture,
                stopVideo: false
              }
            }

            this.initSwiperBanner()

            this.initSwiperExhibit()  // todo联调
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getCollect(type) {
      this.$http
        .get('/webapi/collection/list', {
          yearType: this.activeYear
        })
        .then(res => {
          if (res.success) {
            this.collectData = res.data.records
            if(type == 'refresh') {
              this.mySwiper.slideTo(0)
            } else {
              this.initSwiper2()
              this.initSwiper3()
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    initSwiperBanner() {
      this.$nextTick(() => {
        let swiper = new Swiper(".swiper-container1", {
          // centeredSlides: true,
          effect: 'fade',
          // fade: {
          //   crossFade: true,
          // },
          // autoplay: true,
          // speed: 5000,
          autoplay: 5000,
          loop: true,
          // prevButton:'.swiper-button-prev',
          // nextButton:'.swiper-button-next',
          pagination: '.swiper-container1 .swiper-pagination1',
          paginationClickable: true,
          autoplayDisableOnInteraction: false, // 用户操作 swiper 之后自动切换不会停止
          // 768: {  //当屏幕宽度小于等于768
          //   slidesPerView: 2,
          //   spaceBetween: 20,
          // },
          // 1200: {
          //   //当屏幕宽度小于等于320
          //   slidesPerView: 1,
          //   spaceBetween: 10
          // },
          // prevButton:'.banner-box .swiper-button-prev',
          // nextButton:'.banner-box .swiper-button-next',
          // onSlideChangeStart: function(swiper){
          //   // console.log(swiper.realIndex)
          //   vm.swiperBannerIndex = swiper.realIndex + 1;
          //   vm.currentBanner = vm.data.indexBanner[swiper.realIndex]
          //   if(vm.swiperBannerIndex < vm.data.indexBanner.length) {
          //     vm.nextBanner = vm.data.indexBanner[vm.swiperBannerIndex]
          //   } else {
          //     vm.nextBanner = vm.data.indexBanner[0]
          //   }
          // }
          // navigation: {
          //   nextEl: '.swiper-container3 .swiper-button-next',
          //   prevEl: '.swiper-container3 .swiper-button-prev'
          // },
          // on: {
          //   slideChange: function() {
          //     vm.swiperColectIndex = this.realIndex + 1;
          //   }
          // }
        })
      })
    },
    initSwiper2() {
      this.$nextTick(() => {
        this.mySwiper = new Swiper(".section-display .swiper-container.swiper-display-container", {
          // loop: true,
          // loopAdditionalSlides: 2,
          // autoplay: 5000,
          slidesPerView: this._isMobile ? 1 : 4,
          spaceBetween: this._isMobile ? 0: 40,
          observer: true,
          observeParents: true,
          prevButton: '.section-display .swiper-box .swiper-button-prev',
          nextButton: '.section-display .swiper-box .swiper-button-next',
          // pagination: '.section-display .swiper-pagination-display',
          paginationClickable: true,
          autoplayDisableOnInteraction: false, // 用户操作 swiper 之后自动切换不会停止
        })
        // setTimeout(() => {
        //   this.mySwiper.slideTo(0)
        // }, 1000)
      })
    },
    initSwiper3() {
      this.$nextTick(() => {
        this.mySwiper2 = new Swiper(".section-display .swiper-container.swiper-year-container", {
          // loop: true,
          // loopAdditionalSlides: 2,
          // autoplay: 5000,
          // slidesPerView: 10,
          slidesPerView: this._isMobile ? 3 : 10,
          spaceBetween: this._isMobile ? 8: 8,
          observer: true,
          observeParents: true,
          prevButton: '.section-display .year-list .swiper-button-prev',
          nextButton: '.section-display .year-list .swiper-button-next',
          // pagination: '.section-display .swiper-pagination-display',
          paginationClickable: true,
          autoplayDisableOnInteraction: false, // 用户操作 swiper 之后自动切换不会停止
        })
        // setTimeout(() => {
        //   this.mySwiper.slideTo(0)
        // }, 1000)
      })
    },

    initSwiperExhibit() {
      let vm = this
      this.$nextTick(() => {
        let swiper = new Swiper(".swiper-exhibit-container", {
          // centeredSlides: true,
          effect: 'fade',
          // fade: {
          //   crossFade: true,
          // },
          // autoplay: true,
          // speed: 5000,
          autoplay: 5000,
          loop: true,
          // prevButton:'.swiper-button-prev',
          // nextButton:'.swiper-button-next',
          pagination: '.swiper-exhibit-container .swiper-pagination1',
          paginationClickable: true,
          autoplayDisableOnInteraction: false, // 用户操作 swiper 之后自动切换不会停止
          // 768: {  //当屏幕宽度小于等于768
          //   slidesPerView: 2,
          //   spaceBetween: 20,
          // },
          // 1200: {
          //   //当屏幕宽度小于等于320
          //   slidesPerView: 1,
          //   spaceBetween: 10
          // },
          // prevButton:'.banner-box .swiper-button-prev',
          // nextButton:'.banner-box .swiper-button-next',
          onSlideChangeStart: function(swiper){
            vm.exhiIndex = swiper.realIndex
            console.log(vm.exhiIndex)
            // vm.swiperBannerIndex = swiper.realIndex + 1;
            // vm.currentBanner = vm.data.indexBanner[swiper.realIndex]
            // if(vm.swiperBannerIndex < vm.data.indexBanner.length) {
            //   vm.nextBanner = vm.data.indexBanner[vm.swiperBannerIndex]
            // } else {
            //   vm.nextBanner = vm.data.indexBanner[0]
            // }
          }
          // navigation: {
          //   nextEl: '.swiper-container3 .swiper-button-next',
          //   prevEl: '.swiper-container3 .swiper-button-prev'
          // },
          // on: {
          //   slideChange: function() {
          //     // vm.swiperColectIndex = this.realIndex + 1;

          //     console.log('=====', this.realIndex)
          //   }
          // }
        })
      })
    },
    changeYear(item) {
      this.activeYear = item.val
      this.getCollect('refresh')
    },
    goDetail(val, item) {
      console.log(val, 334)
      switch(val) {
        // 信息
        case '1':
          this.$router.push({
            path: '/information',
            query: { pageType: '3' }
          })
          break
        // 参观预约
        case '2':
          this.$router.push({
            path: '/visit',
            query: { pageType: '2' }
          })
          break
        // 展览详情
        case '3':
          this.$router.push({
            path: '/exhibition/detail',
            query: { id: item.id }
          })
          break
        // 藏品详情
        case '4':
          this.$router.push({
            path: '/collect/detail',
            query: { id: item.id }
          })
          break
        // 失物登记
        case '5':
          this.$router.push({
            path: '/service',
            query: { pageType: '2' }
          })
          break
        // 留言
        case '6':
          this.$router.push({
            path: '/service',
            query: { pageType: '3' }
          })
          break
        // 信息详情
        case '7':
          this.$router.push({
            path: '/information/detail',
            query: { id: item.id }
          })
          break
        // 展览
        case '8':
          this.$router.push({
            path: '/exhibition',
          })
          break
        // 藏品更多
        case '9':
          this.$router.push({
            path: '/collect',
          })
          break
        // 社会教育
        case '10':
          this.$router.push({
            path: '/activity',
          })
          break
        // 文创
        case '11':
          this.$router.push({
            path: '/product',
          })
          break
      }
    },
    goOutLink(item) {
      console.log(item.url)
      item.url && window.open(item.url)
    },
    handleOpen(item, index) {
      this.$set(item, 'active', !item.active)
    },
    goPrev() {
      if(this.videoIndex <1 ) return

      this.videoIndex = this.videoIndex - 1
      // this.detailData = this.testVideoList[this.videoIndex]

      this.detailData = {
        id: this.testVideoList[this.videoIndex].id,
        name: this.testVideoList[this.videoIndex].name,
        url: this.testVideoList[this.videoIndex].video,
        picUrl: this.testVideoList[this.videoIndex].picture,
        stopVideo: false
      }
    },
    goNext() {
      if(this.videoIndex == this.testVideoList.length-1) return

      this.videoIndex = this.videoIndex + 1
      // this.detailData = this.testVideoList[this.videoIndex]

      this.detailData = {
        id: this.testVideoList[this.videoIndex].id,
        name: this.testVideoList[this.videoIndex].name,
        url: this.testVideoList[this.videoIndex].video,
        picUrl: this.testVideoList[this.videoIndex].picture,
        stopVideo: false
      }
    },
    // handleScroll() {
    //   console.log(223)
    // }
  },
  created() {
    this.getData()
    this.getCollect()
  },
  // mounted() {
  //   console.log(333)
  //   window.addEventListener('scroll', this.handleScroll, true)
  // },
  // beforeDestroy() {
  //   window.removeEventListener('scroll', this.handleScroll, true)
  // }
}
</script>

<style lang="scss">
.home-wrap {
  color: #fff;
  background: #fff;
  .swiper-container1 {
    position: relative;
    width: 100%;
    height: 680px;
    overflow: hidden;
    .swiper-slide {
      position: relative;
      width: 100%;
      height: 100%;
      // height: 520px;
      // background-image: url(~@images/home/banner.jpg);
      // // background-position: center top;
      // background-position: center center;
      // background-repeat: no-repeat;
      // background-size: cover;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        // transform: scale(1);
        // transition: all 5s;
      }
      // &:after {
      //   content: '';
      //   position: absolute;
      //   left: 0;
      //   top: 0;
      //   width: 100%;
      //   height: 100%;
      //   background: radial-gradient(
      //     rgba(255, 255, 255, 0),
      //     rgba(241, 241, 241, 0.05),
      //     rgba(17, 17, 17, 0.93),
      //     #000000
      //   );
      //   opacity: 0.5;
      // }
      &.swiper-slide-active {
        img {
          // transform: scale(1.03);
        }
      }
    }

    // image.active {
    //   transform:none;
    //   transition:all 0.2s ease-in0s;
    // }

    // image.quiet {
    //   transform: scale(0.8333333);
    //   transition:all 0.2s ease-in0s;
    // }

    // /deep/ .swiper-pagination-bullet-active {
    //   background: #fff;
    // }

    .swiper-pagination-bullet {
      bottom: 24px;
      width: 20px !important;
      height: 42px !important;
      // border-radius: 100%;
      background: url(~@images/icon-bullet.png) no-repeat center center !important;
      background-size: 100% 100% !important;
      opacity: 0.3;
    }
    .swiper-pagination-bullet-active {
      // background: $primary !important;
      background: url(~@images/icon-bullet-active.png) no-repeat center center !important;
      background-size: 100% 100% !important;
      opacity: 1;
    }
  }

  .section {
    position: relative;
    width: 1600px;
    margin: 0 auto;

    .btn-more-black {
      width: 240px;
      height: 50px;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url(~@images/more-line-black.png) no-repeat center center;
      background-size: 100% 100%;
      cursor: pointer;
      &:hover {
        opacity: 0.9;
        // background: url(~@images/more-line-black-active.png) no-repeat center center;
        // background-size: 100% 100%;
      }
    }
  }

  .section-info,
  .section-exhibit {
    h1 {
      font-size: 48px;
      font-weight: bold;
      margin-bottom: 4px;
    }
    .eng {
      font-size: 18px;
    }
  }

  .section-info {
    margin-top: 37px;
    margin-bottom: 22px;
    overflow: hidden;
    display: flex;
    .item {
      position: relative;
      height: 460px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: url(~@images/bg1.png) repeat;
      // background-size: 14px auto;
      &:nth-child(3) {
        background: url(~@images/bg4.png) repeat;
        // background-size: 50px auto;
      }
      .btn-more {
        width: 240px;
        height: 50px;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url(~@images/more-line.png) no-repeat center center;
        background-size: 100% 100%;
        cursor: pointer;
        &:hover {
          // opacity: 0.8;
          background: url(~@images/more-line-active.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }
    }
    .item-l {
      width: 25%;
    }
    .item-c {
      width: 37.5%;
      padding-right: 190px;
      box-sizing: border-box;
      align-items: initial;
      .it {
        font-size: 18px;
        margin-bottom: 37px;
        cursor: pointer;
        .time {
          margin-bottom: 4px;
        }
      }
      .anim-circle {
        display: block;
        width: 182px;
        height: 462px;
        background: url(~@images/pattern-circle.png) no-repeat center center;
        background-size: 84% 84%;
        position: absolute;
        bottom: 10px;
        right: -10px;
        // animation: anim1 18s linear infinite;
        // // animation: round 18s cubic-bezier(.5, .5, .5, .5) infinite;
        
        // @keyframes anim1{       
		 
        //   0%{-webkit-transform:rotate(0deg);}
      
        //   50%{-webkit-transform:rotate(180deg);}
      
        //   100%{-webkit-transform:rotate(360deg);}
        // }
      }
    }
    .item-r {
      margin-left: 30px;
      flex: 1;
      .tip {
        margin-top: 20px;
      }
      .time-range {
        display: flex;
        align-items: center;
        font-size: 14px;
        margin: 20px 0;
        .name {
          opacity: 0.75;
        }
        .time {
          font-size: 32px;
          font-weight: bold;
        }
        .line {
          margin: 0 24px;
          width: 80px;
          height: 3px;
          background: url(~@images/time-line.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }
      .tickt {
        position: relative;
        z-index: 3;
        .pic-pop.anim {
          // width: calc(37.5vw * 70%);
          // box-sizing: border-box;
          display: flex;
          z-index: 2;
          position: absolute;
          right: 120px;
          bottom: 100%;
          transform: translateX(50%);
          // left: 50%;
          margin-bottom: 10px;
          opacity: 0;
          padding: 20px;
          visibility: hidden;
          border-radius: 5px;
          // transition: all 0.3s;
          background: #fff;
          color: #000;
          // &::before {
          //   content: '';
          //   width: 12px;
          //   height: 12px;
          //   background-color: #fff;
          //   border: 1px solid #ddd;
          //   position: absolute;
          //   z-index: -1;
          //   left: 50%;
          //   top: 100%;
          //   transform: translate(-50%, -50%) rotate(45deg);
          // }
          // &:after {
          //   content: '';
          //   position: absolute;
          //   z-index: -1;
          //   top: 0;
          //   bottom: 0;
          //   left: 0;
          //   right: 0;
          //   background-color: #fff;
          //   border-radius: 5px;
          // }
          .pic {
            width: 140px;
            margin-right: 20px;
            text-align: center;
            img {
              width: 100%;
              height: 140px;
            }
            p {
              font-size: 14px;
              margin-top: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              .icon {
                width: 24px;
                height: 24px;
                margin-right: 5px;
                &.icon-1 {
                  background: url(~@images/icon-1.png) no-repeat center center;
                  background-size: 100% 100%;
                }
                &.icon-2 {
                  background: url(~@images/icon-2.png) no-repeat center center;
                  background-size: 100% 100%;
                }
                &.icon-3 {
                  background: url(~@images/icon-3.png) no-repeat center center;
                  background-size: 100% 100%;
                }
              }
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
        &:hover {
          .pic-pop {
            opacity: 1;
            visibility: visible;
          }
          // .pic-pop.anim {
          //   transform: translate(-50%, 0%);
          // }
        }
      }
      &::before {
        content: '';
        display: block;
        width: 380px;
        height: 82px;
        background: url(~@images/pattern1.png) no-repeat center center;
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      &::after {
        content: '';
        display: block;
        width: 380px;
        height: 82px;
        background: url(~@images/pattern2.png) no-repeat center center;
        background-size: 100% 100%;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
      }
    }
  }

  .section-exhibit1 {
    display: flex;
    margin-bottom: 30px;
    .left {
      position: relative;
      width: 62.5%;
      // margin: 30px;
      .intro-box {
        display: flex;
        background: url(~@images/pic_grey2.png) repeat center center;
        .it_title {
          width: 40%;
          height: 260px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #0E0E0E;
          // background: url(~@images/pic_grey2.png) repeat center center;
          // background-size: cover;
          h1 {
            font-size: 48px;
            font-weight: bold;
          }
          .eng {
            font-size: 18px;
            font-weight: normal;
          }
          .btn-box {
            display: flex; 
            justify-content: flex-end;
          }
        }
        .intro {
          padding-top: 40px;
          padding-right: 190px;
          width: 60%;
          box-sizing: border-box;
          color: #0E0E0E;
          .name {
            font-size: 24px;
            margin-bottom: 20px;
          }
          .desc {
            font-size: 18px;
            line-height: 1.5;
            margin-bottom: 20px;
          }
        }
      }
      .pic {
        img {
          width: 100%;
          height: 512px;
          // object-fit: cover;
          object-fit: contain;
          background: #f6f6f6;
        }
      }
    }
    .right {
      position: relative;
      width: 35.625%;
      // flex: 1;
      margin-left: 30px;
      .collect-box {
        width: 100%;
        display: flex;
        .item {
          position: relative;
          width: 50%;
          height: 508px;
          // background: url(~@images/collect-item1.png) no-repeat center center;
          // background-size: cover;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            // object-fit: cover;
            object-fit: contain;
            // background: #f6f6f6;
            background: #000;
            border: solid 1px #f6f6f6;
          }
        }
      }
      .it_title {
        height: 264px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #0E0E0E;
        background: url(~@images/pic_grey2.png) repeat center center;
        // background-size: cover;
        h1 {
          font-size: 48px;
          font-weight: bold;
        }
        .eng {
          font-size: 18px;
          font-weight: normal;
        }
        .btn {
          margin-top: 30px;
        }
      }
    }

    .swiper-exhibit-container {
      position: relative;
      // width: 100%;
      // height: 680px;
      // overflow: hidden;

      .swiper-pagination {
        // bottom: 5px;
      }

      .swiper-pagination-bullet {
        // bottom: 24px;
        width: 40px !important;
        height: 8px !important;
        border-radius: 4px;
        background: rgba($color: #FFFFFF, $alpha: .5);
        // border-radius: 100%;
        // background: url(~@images/icon-bullet.png) no-repeat center center !important;
        // background-size: 100% 100% !important;
        // opacity: 0.3;
      }
      .swiper-pagination-bullet-active {
        background: #FFFFFF;
        // background: $primary !important;
        // background: url(~@images/icon-bullet-active.png) no-repeat center center !important;
        // background-size: 100% 100% !important;
        // opacity: 1;
      }
    }
  }

  .section-video {
    // height: 840px;
    padding: 50px 0;
    background: rgb(249, 247, 243);
    // background: url(~@images/bg2.png) repeat center center;
    .btn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 72px;
      height: 72px;
      background: #B1923D;
      border-radius: 50%;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: initial;
      }
      i {
        width: 13px;
        height: 26px;
        background: url(~@images/icon_right@2x.png) no-repeat center center;
        background-size: 100% 100%;
      }
      &.btn-left {
        left: 58px;
        transform: translateY(-50%) rotate(180deg);
      }
      &.btn-right {
        right: 58px;
      }
    }
    .name-box {
      display: flex;
      align-items: center;
      padding: 32px 85px 24px;
      font-weight: 400;
      font-size: 24px;
      line-height: 56px;
      // color: #FEFEFE;
      color: #000;
      .icon-box {
        margin-right: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 56px;
        height: 56px;
        background: #0E0E0E;
        border-radius: 50%;
        img {
          width: 28px;
          height: 34px;
        }
      }
    }
    .video-wrap {
      display: flex;
      justify-content: center;
    }
    .video-box {
      // width: 1280px;
      // height: 720px;

      width: 800px;
      // height: 533px;

      // display: flex;
      // align-items: center;
      // justify-content: center;
      // background-color: #000;
    }
  }

  .section-activity {
    margin: 30px auto;
    margin-bottom: 0;
    padding-bottom: 30px;
    display: flex;
    .item {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 400px;
      flex: 1;
      background: url(~@images/leave-1.png) no-repeat center center;
      background-size: cover;
      &:first-child {
        margin-right: 30px;
      }
      &:nth-child(2) {
        background: url(~@images/leave-2.png) no-repeat center center;
        background-size: cover;
      }

      .txt {
        width: 370px;
        height: 100px;
        background: rgba(#fff, .7);
        color: rgba(#0E0E0E, .9);
        font-size: 30px;
        font-weight: bold;
        padding: 0 40px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        .eng {
          font-size: 18px;
          font-weight: normal;
          color: #0E0E0E;
        }
        .icon-arrow {
          width: 13px;
          height: 26px;
          // width: 32px;
          // height: 32px;
          background: url(~@images/icon-arrow.png) no-repeat center center;
          background-size: 100% 100%;
        }
        &:hover {
          // background: rgba(255, 255, 255, 0.95)
          // background: #272121;
          // color: #fff;
          // .icon-arrow {
          //   background: url(~@images/icon-arrow-active.png) no-repeat center center;
          //   background-size: 100% 100%;
          // }
        }
      }
    }
  }



  .section-exhibit {
    .item {
      position: relative;
      height: 400px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .item-l {
      background: linear-gradient(0deg, #1C1E24, #1C1E24), rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(360px);
    }
    .item:nth-child(2),
    .item:nth-child(3) {
      overflow: hidden;
      cursor: pointer;
      .pic-box {
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .info {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 90px;
        // height: 172px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        // background: rgba(0, 0, 0, 1);
        background: rgba(0, 0, 0, 0.4);
        backdrop-filter: blur(360px);
        transform: translateY(100%);
        // transition: transform .3s ease-in-out;
        transition: transform .3s cubic-bezier(.4,0,.2,1);
        h2 {
          padding-left: 20px;
          font-size: 32px;
          font-weight: 500;
          // margin-bottom: 22px;
          width: 100%;
          text-align: center;
          box-sizing: border-box;
        }
        .time {
          font-size: 18px;
        }
      }
      &:hover {
        .info {
          transform: translateY(0);
        }
      }
    }
  }

  .section-display {
    .tab-wrap {
      padding: 80px 0 180px;
      background: #222222;
      overflow: hidden;
      .year-list {
        position: relative;
        width: $minWidth;
        margin: 0 auto 60px;
        // display: flex;
        .swiper-slide {
          // margin-right: 1px;
          opacity: 0.5;
          cursor: pointer;
          .line {
            // width: 106px;
            width: 100%;
            height: 8px;
            // background: #3EEDE7;
            border-top: solid 3px #3EEDE7;
            box-sizing: border-box;
          }
          .name {
            margin: 16px 0 8px;
            font-size: 14px;
            color: #3EEDE7;
          }
          .year {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.7);
          }
          &.active {
            opacity: 1;
            font-weight: bold;
            .line {
              // height: 8px;
              border-top-width: 8px;
            }
          }
          &:nth-child(2) {
            .line {
              border-top-color: #FF839E;
            }
            .name {
              color: #FF839E;
            }
          }
          &:nth-child(3) {
            .line {
              border-top-color: #78CAFF;
            }
            .name {
              color: #78CAFF;
            }
          }
          &:nth-child(4) {
            .line {
              border-top-color: #1877EC;
            }
            .name {
              color: #1877EC;
            }
          }
          &:nth-child(5) {
            .line {
              border-top-color: #F6A067;
            }
            .name {
              color: #F6A067;
            }
          }
          &:nth-child(6) {
            .line {
              border-top-color: #EBDF8D;
            }
            .name {
              color: #EBDF8D;
            }
          }
          &:nth-child(7) {
            .line {
              border-top-color: #C883D4;
            }
            .name {
              color: #C883D4;
            }
          }
          &:nth-child(8) {
            .line {
              border-top-color: #BDBDBD;
            }
            .name {
              color: #BDBDBD;
            }
          }
          &:nth-child(9) {
            .line {
              border-top-color: #6D54C0;
            }
            .name {
              color: #6D54C0;
            }
          }
          &:nth-child(10) {
            .line {
              border-top-color: #3A9E61;
            }
            .name {
              color: #3A9E61;
            }
          }
          &:nth-child(11) {
            .line {
              border-top-color: #FF839E;
            }
            .name {
              color: #FF839E;
            }
          }
          &:nth-child(12) {
            .line {
              border-top-color: #8A74FD;
            }
            .name {
              color: #8A74FD;
            }
          }
          &:nth-child(13) {
            .line {
              border-top-color: #78CAFF;
            }
            .name {
              color: #78CAFF;
            }
          }
          &:nth-child(14) {
            .line {
              border-top-color: #1877EC;
            }
            .name {
              color: #1877EC;
            }
          }
          &:nth-child(15) {
            .line {
              border-top-color: #F6A067;
            }
            .name {
              color: #F6A067;
            }
          }
          &:nth-child(16) {
            .line {
              border-top-color: #EBDF8D;
            }
            .name {
              color: #EBDF8D;
            }
          }
          &:nth-child(17) {
            .line {
              border-top-color: #C883D4;
            }
            .name {
              color: #C883D4;
            }
          }
        }

        /*先去掉默认样式*/
        .swiper-button-prev:after {
          display: none;
        }
        .swiper-button-next:after {
          display: none;
        }
        .swiper-button-prev,
        .swiper-button-next {
          position: absolute;
          left: 0;
          top: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 40px;
          height: 70px;
          background: linear-gradient(90deg, #222222 0%, rgba(34, 34, 34, 0) 100%);
          &.swiper-button-disabled {
            display: none;
          }
        }
        .swiper-button-next {
          right: 0;
          left: initial;
          background: linear-gradient(270deg, #222222 0%, rgba(34, 34, 34, 0) 100%);
        }
        /*再自定义样式*/
        .swiper-button-prev i {
          width: 20px;
          height: 20px;
          background: url('~@images/icon-right.png') no-repeat;
          background-size: 100% 100%;
          transform: rotate(180deg);
        }
        .swiper-button-next i {
          width: 20px;
          height: 20px;
          background: url('~@images/icon-right.png') no-repeat;
          background-size: 100% 100%;
        }
        
      }
    }


    .swiper-box {
      position: relative;
      width: $minWidth;
      margin: 0 auto;
    }
    // .swiper-box {
    //   width: 1200px;
    //   margin: 0 auto;
    //   display: flex;
    //   position: relative;
    // }

    .swiper-wrapper {
      position: inherit;
    }

    .swiper-container {
      padding-bottom: 30px;
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
    }
    .swiper-slide {
      position: relative;
      // flex-basis: 386px;
      // flex-shrink: 0;
      // height: 500px;
      font-size: 18px;
      transition: 300ms;
      display: flex;
      flex-direction: column;
      cursor: pointer;
      overflow: hidden;
      .pic_bg {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        filter: blur(30px);
        background-size: cover;
        // backdrop-filter: blur(30px); /* 模糊半径 */
      }
      .pic-box {
        flex-shrink: 0;
        box-sizing: border-box;
        position: relative;
        height: 289px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          transition: all 0.6s;
        }
      }

      &:hover {
        .pic-box {
          img{
            transform: scale(1.02);
          }
        }
      }
    }
    .swiper-box {
      /*先去掉默认样式*/
      .swiper-button-prev:after {
        display: none;
      }
      .swiper-button-next:after {
        display: none;
      }
      /*再自定义样式*/
      .swiper-button-prev {
        width: 32px;
        height: 32px;
        background: url('~@images/icon-right.png') no-repeat;
        background-size: 100% 100%;
        left: -52px;
        transform: rotate(180deg);
      }
      .swiper-button-next {
        right: -52px;
        width: 32px;
        height: 32px;
        background: url('~@images/icon-right.png') no-repeat;
        background-size: 100% 100%;
      }
    }

  }

  .section-leave {
    .item {
      height: 400px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url(~@images/leave-1.png) no-repeat center center;
      background-size: cover;
      &:nth-child(2) {
        background: url(~@images/leave-2.png) no-repeat center center;
        background-size: cover;
      }
      .txt {
        width: 370px;
        height: 100px;
        background: #fff;
        color: #000;
        cursor: pointer;
        font-size: 30px;
        font-weight: bold;
        padding: 0 40px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .icon-arrow {
          width: 32px;
          height: 32px;
          background: url(~@images/icon-arrow.png) no-repeat center center;
          background-size: 100% 100%;
        }
        &:hover {
          // background: rgba(255, 255, 255, 0.95)
          background: #272121;
          color: #fff;
          .icon-arrow {
            background: url(~@images/icon-arrow-active.png) no-repeat center center;
            background-size: 100% 100%;
          }
        }
      }
    }
  }

  .section-question {
    padding: 80px 0;
    background: url(~@images/bg3.png) repeat;
    .question-con {
      margin: 0 auto;
      color: #fff;
      h2 {
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 40px;
      }
      .list {
        .item {
          font-size: 16px;
          border-bottom: solid 1px rgba(255, 255, 255, 0.3);
          .title-box {
            padding: 20px 0;
            font-size: 24px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
          }
          .icon-expand {
            width: 32px;
            height: 32px;
            background: url(~@images/icon-expand.png) no-repeat center center;
            background-size: cover;
            cursor: pointer;
          }
          .res {
            display: none;
            padding-bottom: 20px;
          }
          &.active {
            .icon-expand {
              background: url(~@images/icon-expand-active.png) no-repeat center center;
              background-size: cover;
            }
            .res {
              display: block;
            }
          }
        }
      }
    }
  }

  &.pc {
    .section-question {
      .question-con {
        // width: 1142px;
        width: $minWidth;
      }
    }
    .section-display {
      .tab-wrap {
        .year-list {
          .swiper-slide {
            &:hover {
              opacity: 1;
              font-weight: bold;
              .line {
                // height: 8px;
                border-top-width: 8px;
              }
            }
          }
        }
      }
    }
  }
}
</style>

